import moment from 'moment';
import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-phone-number-input/style.css';
import { RouteComponentProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import Spinner from '../../components/common/Spinner';
import { ErrorToast } from '../../components/common/Toasts/Toasts';
import { validateEmail } from '../../helpers/helperFunctions';
import { AuthLayoutTitle, Flexed } from '../../styles/GlobalComponents';
import { Label, PhoneComp } from '../../styles/stylesStyled';
import {
  addEmailAndVerificationCode,
  addEmailToNewTeamMember
} from './EmailAddress.actions';

type TParams = { childPosition?: string; id?: string };

const captchaId = process.env.REACT_APP_CAPTCHA_ID;

const EmailAddress = ({ history, match }: RouteComponentProps<TParams>) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('onboarding');

  const [email, setEmail] = useState('');
  const [email2, setEmail2] = useState('');
  const [captchaLoading, setCaptchaLoading] = useState(false);

  const { register, loading } = useAppSelector((state) => state.auth);

  const { approvalDate, referrerId } = register;

  const sendEmail = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) {
      ErrorToast(t('email_address.error_email_empty'));
      return;
    }
    if (!validateEmail(email)) {
      ErrorToast(t('email_address.error_email_invalid'));
      return;
    }

    if (email !== email2) {
      ErrorToast(t('email_address.error_email_match'));
      return;
    }

    if (match.params.childPosition) {
      dispatch(
        addEmailToNewTeamMember({
          parentId: Number(match.params.id),
          childPosition: Number(match.params.childPosition),
          email,
          history
        })
      );
    } else {
      setCaptchaLoading(true);
      window?.initGeetest4(
        {
          captchaId,
          language: 'eng',
          product: 'bind',
          riskType: 'slide',
          nativeButton: {
            width: '100%',
            marginBottom: '20px'
          }
        },
        function (captcha: any) {
          captcha.showBox();
          captcha
            .onReady(function () {
              setCaptchaLoading(false);
            })
            .onSuccess(function () {
              const result = captcha.getValidate();

              dispatch(
                addEmailAndVerificationCode({
                  approvalDate: approvalDate || moment().format(),
                  referrerId: referrerId
                    ? Number(referrerId)
                    : Number(match.params.id),
                  email,
                  result,
                  history
                })
              );
            })
            .onError(function () {
              setCaptchaLoading(false);
            });
        }
      );
    }
  };

  return (
    <>
      {(loading || captchaLoading) && <Spinner fullScreen={true} transparent />}
      <AuthLayoutTitle>
        {match.params.id
          ? t('email_address.register_new_user')
          : t('email_address.enter_email_address')}
      </AuthLayoutTitle>

      <Flexed m='10px 0'></Flexed>

      <form onSubmit={sendEmail}>
        <Label>Email Address</Label>
        <InputBackOffice
          id={'email'}
          type={'text'}
          placeholder={
            match.params.id
              ? t('email_address.enter_users_email_placeholder')
              : t('email_address.enter_your_email_placeholder')
          }
          name={'email'}
          value={email.replace(/\s+/g, '')}
          onChange={(e: string) => setEmail(e.replace(/\s+/g, ''))}
          label={t('email_address.label')}
        />

        <Label>Confirm</Label>
        <InputBackOffice
          id={'email'}
          type={'text'}
          placeholder={t('email_address.repeat_email_placeholder')}
          name={'email'}
          value={email2.replace(/\s+/g, '')}
          onChange={(e: string) => setEmail2(e.replace(/\s+/g, ''))}
          label={t('email_address.label')}
        />

        <Button
          negative
          m='20px 0 0 0'
          type='submit'
          disabled={email === '' && email2 === ''}>
          {t('email_address.button_text')}
        </Button>
      </form>
    </>
  );
};

export default EmailAddress;
